module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-wrap"
  }, [_c('div', {
    staticClass: "empty-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgpath
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.emptytext))]), _vm._v(" "), (_vm.btntext) ? _c('mu-raised-button', {
    attrs: {
      "label": _vm.btntext
    },
    on: {
      "click": function($event) {
        return _vm.doUrl(_vm.btnurl)
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bfa406a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/empty/empty.vue
// module id = 398
// module chunks = 68